import { Typography } from "@material-ui/core"
import ContentArea from "../../cmp/content/ContentArea";

const SessionInvalidPage = () => {
    return (
        <ContentArea>
            <div>
                <Typography variant='h3' color='textPrimary'>Ups, es tut uns leid.</Typography>
            </div>
            <div style={{ marginTop: 10 }}>
                <Typography variant='body1' color='textPrimary'>Ihre Session ist abgelaufen. Bitte verwenden Sie erneut den ursprünglichen Link, um neu anzufangen.</Typography>
            </div>
        </ContentArea>);
}

export default SessionInvalidPage;